export default __webpack_public_path__ + "static/media/saint-malo11.72632ff7.jpg";